export default {
    topics: [
        {
            title: ' FillSteps ',
            href: 'sm-abstractForm-FillSteps.html',
            attributes: { 'data-id': 'sm-abstractForm-FillSteps' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-FillSteps-d66e87',
            topics: [],
        },
        {
            title: ' FillStepsWithFilter ',
            href: 'sm-abstractForm-FillStepsWithFilter.html',
            attributes: { 'data-id': 'sm-abstractForm-FillStepsWithFilter' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-FillStepsWithFilter-d66e95',
            topics: [],
        },
        {
            title: ' GetInputValues ',
            href: 'sm-abstractForm-GetInputValues.html',
            attributes: { 'data-id': 'sm-abstractForm-GetInputValues' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-GetInputValues-d66e103',
            topics: [],
        },
        {
            title: ' GetSource ',
            href: 'sm-abstractForm-GetSource.html',
            attributes: { 'data-id': 'sm-abstractForm-GetSource' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-GetSource-d66e111',
            topics: [],
        },
        {
            title: ' GetSourceAsHtml ',
            href: 'sm-abstractForm-GetSourceAsHtml.html',
            attributes: { 'data-id': 'sm-abstractForm-GetSourceAsHtml' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-GetSourceAsHtml-d66e119',
            topics: [],
        },
        {
            title: ' SelectTopValues ',
            href: 'sm-abstractForm-SelectTopValues.html',
            attributes: { 'data-id': 'sm-abstractForm-SelectTopValues' },
            menu: { hasChildren: false },
            tocID: 'sm-abstractForm-SelectTopValues-d66e127',
            topics: [],
        },
    ],
};

